import React from 'react'
import Verify from './Verify'
import { useParams } from 'react-router-dom'
import PropTypes from 'prop-types'
import Complete from 'App/Pages/Auth/VerifyEmail'

const VerifyEmailError = ({ message }) => {
  const { hasToken } = useParams()
  console.log('hasToken', hasToken)

  return hasToken ? <Complete /> : <Verify message={message} />
}

VerifyEmailError.propTypes = {
  message: PropTypes.string,
}

export default VerifyEmailError
